import { API, graphqlOperation } from "aws-amplify";

import { listCognitoGroups } from "./graphql/queries";

const getAllCognitoGroups = (username) =>
  API.graphql(graphqlOperation(listCognitoGroups));

export default getAllCognitoGroups;
